import type { SelectProps } from 'antd/lib/select';
import React from 'react';

import { roleApi } from '../../lib/api';
import type { Role } from '../../lib/types';
import AutocompleteSelect from './AutocompleteSelect';

type Props = SelectProps & {
  filter?: Record<string, unknown>;
};

export default function UserRoleSelect({ filter = {}, ...selectProps }: Props) {
  return (
    <AutocompleteSelect<Role>
      fetch={async (params) => roleApi.fetchRoles({ ...filter, ...params })}
      fetchSingle={roleApi.fetchRole}
      notFoundText="Роли не найдены"
      placeholder="Выберите роль"
      valueKey="id"
      renderOption={(role, Option) => (
        <Option key={role.id} value={role.id} role={role}>
          {role.name}
        </Option>
      )}
      {...selectProps}
    />
  );
}
